import { usePrevious } from '@sequencehq/utils'
import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { usePostHog } from 'posthog-js/react'
import { useEffect, useState } from 'react'

/**
 * Potential for making this a lib function - just testing for now though.
 * @param props
 */
export const useLogLoadTime = (props: {
  eventName: string
  ready: boolean
  metadata?: Record<string, unknown>
}) => {
  const selfQuery = useQuery(dashboardv99990101Client.getSelf)
  const [startOfLoadTime, setStartOfLoadTime] = useState(performance.now())
  const prevReady = usePrevious(props.ready)
  const posthog = usePostHog()

  const currentAccountId = selfQuery.data?.sequenceAccounts[0]

  useEffect(() => {
    if (prevReady === undefined || prevReady === props.ready) return

    if (props.ready && posthog.__loaded) {
      posthog.capture(props.eventName, {
        loadTime: performance.now() - startOfLoadTime,
        ...(props.metadata ?? {}),
        accountId: currentAccountId
      })
    }

    if (!props.ready) {
      /**
       * When we have shifted to not ready again, restart the timer.
       */
      setStartOfLoadTime(performance.now())
    }
  }, [
    props.eventName,
    props.ready,
    startOfLoadTime,
    posthog,
    prevReady,
    props.metadata,
    currentAccountId
  ])
}
